"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesFlow = void 0;
exports.TypesFlow = {
    boot: "flow.boot",
    mainAction: "flow.gameAction",
    assetsPreload: "assets.preload",
    assetsProcess: "assets.process",
    LoadRemoteConfigAction: "flow.remoteConfigAction",
    LevelStart: "flow.levelStart",
    LevelRestart: "flow.levelRestart",
    LevelNext: "flow.LevelNext",
    LevelEnd: "flow.levelEnd",
    PlayWith: "flow.PlayWith",
    share: "flow.share",
    UI: {
        setupAction: "ui.setupAction",
        startScreenAction: "ui.startScreenAction",
        endScreenAction: "ui.endScreenAction"
    }
};
//# sourceMappingURL=TypesFlow.js.map